import { render, staticRenderFns } from "./Delivered-CompanyTable.vue?vue&type=template&id=12319fbe&scoped=true&"
import script from "./Delivered-CompanyTable.vue?vue&type=script&lang=js&"
export * from "./Delivered-CompanyTable.vue?vue&type=script&lang=js&"
import style0 from "./Delivered-CompanyTable.vue?vue&type=style&index=0&id=12319fbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12319fbe",
  null
  
)

export default component.exports